import React from 'react';

const SearchBox = ({ searchChange}) => {
    return(
        <div className='pa2'>
            <input 
                className='pa3 ba br4 b--blue bg-lightest-blue' 
                type='search' 
                placeholder='search cats' 
                onChange={searchChange}
            />
        </div>
    );
}

export default SearchBox;